export enum EPermissoesUnitarias {
    DeletarCliente = 1,
    CarregarBaseTodos = 2,
    CarregarBaseAtivos = 3,
    SelecionarCorretor = 4,
    TempoIlimitadoacesso = 5,
    ComissaoDiretor = 6,
    ComissaoAdvogado = 7,
    BloquearCliente = 8,
    ComissoesRecebidas = 9,
    TotalResultadoLiquido = 10,
    TransferirTodosAnalistas = 11,
    TransferirAnalistaMotivo = 12,
    StatusTransferencia = 13,
    AbaHerdeiros = 14,
    EditarCpfCnpj = 15,
    TransfeirExecutivoSemTipoConhecimentoAtivo = 16,
    MudarPerfil = 17,
    AnaliseClientes = 18,
    ExcluirUsuario = 19,
    PerfilUsuario = 19,
    ConferenciaOperacional = 20,
    Agenda = 21,
    Termometro = 22,
    UsurioOnline = 23,
    ExcluirSolicitacaoDocumento = 24
  }
